export default __webpack_public_path__ + "static/media/fm-rough_inv.ca778887.svg";